// ------------------------ Redux -------------------------------
export const SET_SIMPLE_STATE = '@commonGlobal/store/SET_SIMPLE_STATE';


// ------------------------  Saga --------------------------------
export const GET_STATUS_HABILITAR_FUNCOES_PROJETO = '@commonGlobal/saga/GET_STATUS_HABILITAR_FUNCOES_PROJETO';
